import { createAccessControlFcmConfig } from '../shared/builders/accessControl';

export const FCM_PETITION_FEED_ACCESS_CONFIG = createAccessControlFcmConfig('petition_feed_access_config');
